
import "react-calendar/dist/Calendar.css";
import "./attendance-heat-map.css";
import { eachDayOfInterval, format, parseISO, subDays } from "date-fns";
import { Tooltip } from "@mui/material";

interface AttendanceHeatMapProps {
    presentDates: string[]; // Array of dates in "YYYY-MM-DD" format
    minDate?: Date;
    maxDate?: Date;
}

const AttendanceHeatMap: React.FC<AttendanceHeatMapProps> = (props) => {

    const buildDateMap = () => {
        const end = props.maxDate ?? new Date();
        const start = props.minDate ? props.minDate : subDays(end, 27); // includes today = 30 days

        const presentSet = new Set(props.presentDates);

        const result: Record<string, boolean> = {};

        eachDayOfInterval({ start, end }).forEach(date => {
            const key = format(date, "yyyy-MM-dd");
            result[key] = presentSet.has(key);
        });

        return result;
    }

    function toGrid(
        dateMap: Record<string, boolean>,
        rows = 4,
        cols = 7
    ) {
        const entries = Object.entries(dateMap); // ordered by date

        const grid: { date: string; present: boolean }[][] = [];

        for (let week = 0; week < rows; week++) {
            grid.push(
                entries.slice(week * cols, (week + 1) * cols).map(
                    ([date, present]) => ({ date, present })
                )
            );
        }

        return grid;
    }

    const dateMap = buildDateMap();
    const grid = toGrid(dateMap);

    return (
        <div>
            <div className="attendance-grid-28">
                {grid.map((week, wIdx) => (
                    <div key={wIdx} className="week-row">
                        {week.map(cell => (
                            <Tooltip key={cell.date} title={cell.date}>
                                <div
                                    className={`cell ${cell.present ? "present" : ""}`}
                                    title={cell.date}
                                >
                                    {format(parseISO(cell.date), "d")}
                                </div>
                            </Tooltip>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AttendanceHeatMap;